var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 45,
    viewBox: "0 0 116 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_56_27941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 12.7359C8 11.4613 8.46514 10.3498 9.40139 9.40143C10.3197 8.47117 11.4528 8.00604 12.8005 8.00604H12.884C14.2496 8.00604 15.3945 8.47117 16.3129 9.40143C17.2491 10.3498 17.7143 11.4613 17.7143 12.7359V23.0351C17.7143 25.9165 18.4537 27.7166 19.9267 28.4476C21.4354 29.1966 23.0276 29.0456 24.7033 28.0126C26.2299 27.0642 27.0887 26.0434 27.2676 24.95C27.3033 24.7869 27.3391 24.5513 27.3749 24.2372V12.7298C27.3749 11.4552 27.84 10.3438 28.7763 9.39539C29.6946 8.46513 30.8336 8 32.2052 8H32.3125C33.6782 8 34.8231 8.46513 35.7415 9.39539C36.6777 10.3438 37.1429 11.4552 37.1429 12.7298V32.8995C37.1429 33.7754 36.8089 34.5486 36.147 35.2251C35.5149 35.8655 34.7158 36.1796 33.7437 36.1796H30.6428C29.6887 36.1796 28.8896 35.8534 28.2396 35.1949C27.5896 34.5546 27.2676 34.1499 27.2676 33.9626C24.5185 35.5997 22.6996 36.5118 21.8171 36.693C17.3744 37.6233 13.8679 36.4393 11.2977 33.1411C9.12111 30.3926 8.02386 26.8287 8.00597 22.4552V12.7298L8 12.7359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9837 8.0061C63.6743 8.0061 64.9937 8.69541 65.9362 10.0679C66.8963 11.4771 67.1083 12.9594 66.5605 14.5027L60.6172 31.5526C60.0517 33.1691 59.0798 34.4806 57.7015 35.475C56.3231 36.4937 54.7681 37 53.0422 37H52.9303C51.1867 37 49.614 36.4754 48.2121 35.4201C46.8514 34.4013 45.8972 33.0776 45.3494 31.4367L39.7064 14.4417C39.1822 12.8801 39.4001 11.41 40.3603 10.0374C41.285 8.68321 42.6045 8.0061 44.3127 8.0061H44.831C45.9208 8.0061 46.8927 8.3294 47.7468 8.96382C48.6185 9.64093 49.2017 10.4949 49.4903 11.532C51.87 19.8342 53.2896 25.1292 53.7431 27.4228H52.7889C53.2601 25.2207 54.7268 19.9074 57.1772 11.471C57.4835 10.4522 58.0843 9.61653 58.9738 8.95772C59.8102 8.31721 60.7703 8 61.8659 8H61.9778L61.9837 8.0061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.816 37C73.3676 37 72.1537 36.4936 71.1803 35.4746C70.201 34.4557 69.7142 33.2415 69.7142 31.8321V13.1679C69.7142 11.7768 70.1834 10.5809 71.1275 9.58026C72.142 8.52472 73.3676 8 74.816 8H74.8981C76.329 8 77.5311 8.50642 78.5046 9.52535C79.5015 10.5626 79.9999 11.7768 79.9999 13.1679V31.8321C79.9999 33.2415 79.5132 34.4374 78.5339 35.4197C77.537 36.4753 76.329 37 74.8981 37H74.816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.262 8C105.249 8 106.67 8.89861 107.517 10.6897C108.311 12.4258 108.126 14.0457 106.962 15.5557L101.549 22.4878L106.962 29.4443C108.12 30.9543 108.305 32.5742 107.517 34.3103C106.67 36.1014 105.255 37 103.262 37H103.149C101.418 37 100.093 36.2726 99.1739 34.8238L95.4439 28.9125L91.69 34.8238C90.7889 36.2787 89.464 37 87.7154 37H87.6318C85.6266 37 84.2002 36.1014 83.3528 34.3103C82.5411 32.5742 82.7262 30.9543 83.9078 29.4443L89.3208 22.4878L83.9078 15.5557C82.7321 14.0457 82.5471 12.4258 83.3528 10.6897C84.2002 8.89861 85.6266 8 87.6318 8H87.7154C89.464 8 90.7889 8.72744 91.69 10.1762L95.4439 16.0875L99.1739 10.1762C100.093 8.72133 101.418 8 103.149 8H103.262Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_56_27941",
    x: 0.673612,
    y: 0.673612,
    width: 114.653,
    height: 43.6528,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.66319
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_56_27941"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_56_27941",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logoMobile.dbc2da3092b84b92f7e8c9150d481121.svg";
export { ForwardRef as ReactComponent };